import { gql } from '@apollo/client'

import { GROUP_FRAGMENT } from '../fragments'

export const UPDATE_DAI_GROUP = gql`
  mutation UpdateDaiGroup($data: UpdateDaiGroupInput!) {
    updateDaiGroup(data: $data) {
      ...Group
    }
  }
  ${GROUP_FRAGMENT}
`
